module.exports = __webpack_public_path__ + "img/Arch-Martins2.c133d7a1.jpg";